/**
 * Build-time bundle of every starter/solution file under `src/karelCode/`.
 *
 * Like worlds, these are inlined as raw strings so starter code loads without
 * network requests and the app works offline. The `.js` / `.py` files live in
 * `src/karelCode/` for authoring.
 */
const codeModules = import.meta.glob("../karelCode/**/*.{js,py}", {
  query: "?raw",
  import: "default",
  eager: true,
}) as Record<string, string>;

/**
 * Normalizes a code glob path or user-supplied path to the bundle key: strips
 * everything up to and including `karelCode/`. Accepts `karelCode/u5l1.starter.js`
 * and `apcsp/c1l1.starter.py`.
 */
export function normalizeCodeName(name: string): string {
  return name.replace(/^.*?karelCode\//, "");
}

/** Code text keyed by filename, e.g. `u5l1.starter.js` or `apcsp/c1l1.starter.py`. */
export const karelCodeTextByName: Record<string, string> = Object.fromEntries(
  Object.entries(codeModules).map(([path, text]) => [
    normalizeCodeName(path),
    text,
  ]),
);
